import { render, staticRenderFns } from "./TopLeft.vue?vue&type=template&id=0076bb8c&scoped=true"
import script from "./TopLeft.vue?vue&type=script&lang=js"
export * from "./TopLeft.vue?vue&type=script&lang=js"
import style0 from "./TopLeft.vue?vue&type=style&index=0&id=0076bb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0076bb8c",
  null
  
)

export default component.exports